import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div>
      <p>login sdk</p>
      <p>LOADING...</p>
    </div>
  `,
})
export class CallbackComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly router = inject(Router);

  ngOnInit() {
    this.oidcSecurityService.checkAuth().subscribe((loginResponse) => {
      const { isAuthenticated, accessToken, idToken } = loginResponse;
      if (isAuthenticated) {
        if (accessToken)
          localStorage.setItem('tokenObj', JSON.stringify({ access_token: accessToken }));
        if (idToken) localStorage.setItem('idToken', idToken);
        localStorage.setItem('loginStatus', 'Ok');
        localStorage.setItem('urlReturn', '/');
        this.router.navigate(['/']);
      } else {
        this.router.navigate(['/login']);
      }
    });
  }
}
